const initial_cache = {
    cache_data:{}
}

export default initial_cache